import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExtrapagesRoutingModule } from './extrapages-routing.module';
import { Page404Component } from './page404/page404.component';
import { NoPermissionComponent } from './no-permission/no-permission.component';

@NgModule({
  declarations: [Page404Component, NoPermissionComponent],
  imports: [
    CommonModule,
    ExtrapagesRoutingModule,
  ]
})
export class ExtrapagesModule { }
